import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const chapters = [
  { id: 1, title: "The Classics (1-10)", content: '"I\'m fine," "do what you want," "we need to talk"—the phrases that end relationships daily, decoded with exact scripts to respond.' },
  { id: 2, title: "The Vagueness Trap (11-20)", content: '"Let\'s see what happens," "maybe later," "we\'ll figure it out"—translated so you stop waiting for clarity that never comes.' },
  { id: 3, title: "Early Dating (21-30)", content: '"I\'m not looking for anything serious," "let\'s hang out soon," "I\'ve been busy"—know if they\'re interested or keeping options open.' },
  { id: 4, title: "Digital Dating (31-40)", content: '"Hey" vs. "heyyy," left on read, "you up?" at 2am—decode texts before you reply.' },
  { id: 5, title: "Conflict & Repair (41-50)", content: '"You\'re overreacting," "calm down," "I choose you"—fight fair, repair fast, rebuild stronger.' },
  { id: 6, title: "Intimacy & Desire (61-70)", content: '"Not tonight," "I need more foreplay," "don\'t stop"—understand what they need in bed.' },
  { id: 7, title: "Desire Differences (71-80)", content: '"We used to do it more," "the spark is gone," "I need to feel connected first"—bridge libido gaps without blame.' },
  { id: 8, title: "Long-Term Love (81-90)", content: '"We\'ve changed," "we don\'t talk anymore," "I still choose you"—keep choosing each other decades in.' },
  { id: 9, title: "Commitment Conversations", content: '"Where is this going," "I want a baby," "let\'s move in together"—navigate future-defining moments with clarity.' },
];

const Chapters = () => {
  const [openId, setOpenId] = useState(1);

  return (
    <section className="py-20 bg-brand-gray/30">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">
          100 Translations, Organized by <span className="text-brand-yellow">Relationship Stage</span>
        </h2>

        <div className="max-w-3xl mx-auto grid gap-4">
          {chapters.map((chapter) => (
            <div key={chapter.id} className="bg-brand-black border border-white/10 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenId(openId === chapter.id ? null : chapter.id)}
                className="w-full flex justify-between items-center p-5 text-left hover:bg-white/5 transition-colors"
              >
                <span className={`font-bold ${openId === chapter.id ? 'text-brand-yellow' : 'text-white'}`}>
                  {chapter.title}
                </span>
                <SafeIcon icon={openId === chapter.id ? FiChevronUp : FiChevronDown} className="text-gray-400" />
              </button>
              <AnimatePresence>
                {openId === chapter.id && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    className="overflow-hidden"
                  >
                    <div className="p-5 pt-0 text-gray-400 border-t border-white/5">
                      {chapter.content}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12 bg-brand-yellow/10 p-6 rounded-xl max-w-2xl mx-auto border border-brand-yellow/20">
            <p className="text-brand-yellow font-bold mb-2">PLUS:</p>
            <p className="text-white">Quick-reference cheat sheet • Audio version of key translations • 30-day money-back guarantee</p>
        </div>
      </div>
    </section>
  );
};

export default Chapters;